import { standardList } from "./../../../app.values";
import materialTabService from "@services/requests/material-tab.service";
import { setGroundOptions } from "@reducers/options/ground/actions";
import { APP_TYPES } from "@config";

export const SET_GENERAL_CALC_CONCRETE_STRENGTH = 'SET_GENERAL_CALC_CONCRETE_STRENGTH';
export const SET_GENERAL_CALC_CONCRETE_CONDITIONS = 'SET_GENERAL_CALC_CONCRETE_CONDITIONS';
export const SET_BOND_CONDITIONS = 'SET_BOND_CONDITIONS';

export const SET_REINFORCEMENT_PLATE = 'SET_REINFORCEMENT_PLATE';
export const SET_REINFORCEMENT_EDGE = 'SET_REINFORCEMENT_EDGE';
export const SET_REINFORCEMENT_TO_LIMIT = 'SET_REINFORCEMENT_TO_LIMIT';
export const SET_REINFORCEMENT_LONG_TEMPERATURE = 'SET_REINFORCEMENT_LONG_TEMPERATURE';
export const SET_REINFORCEMENT_SHORT_TEMPERATURE = 'SET_REINFORCEMENT_SHORT_TEMPERATURE';
export const SET_HOLE_CONDITIONS = 'SET_HOLE_CONDITIONS';
export const SET_REINFORCEMENT_TENSION = 'SET_REINFORCEMENT_TENSION';
export const SET_REINFORCEMENT_SHEAR = 'SET_REINFORCEMENT_SHEAR';
export const SET_DRILLING_CONDITIONS = 'SET_DRILLING_CONDITIONS';
export const SET_REINFORCEMENT_SERVICE_TEMPERATURE = 'SET_REINFORCEMENT_SERVICE_TEMPERATURE';

export const SET_REBAR_TEMPERATURE = 'SET_REBAR_TEMPERATURE';
export const SET_REBAR_LONG_ITEM = 'SET_REBAR_LONG_ITEM';
export const SET_REBAR_SHORT_ITEM = 'SET_REBAR_SHORT_ITEM';
export const SET_REBAR_INSTALLATION_CONDITIONS = 'SET_REBAR_INSTALLATION_CONDITIONS';
export const SET_REBAR_HOLE_CONDITIONS = 'SET_REBAR_HOLE_CONDITIONS';
export const SET_REBAR_USING_ORILLING_AID = 'SET_REBAR_USING_ORILLING_AID';

export const SET_LIGHT_WEIGHT_CONCRETE = 'SET_LIGHT_WEIGHT_CONCRETE_LAMBDA';
export const SET_CONCRETE_THICKNESS = 'SET_CONCRETE_THICKNESS';

export const SET_SERVICE_TEMPERATURE = 'SET_SERVICE_TEMPERATURE';

export const SET_MASONRY_DEFINITION_TYPE = 'SET_MASONRY_DEFINITION_TYPE';
export const SET_MASONRY_TYPE = "SET_MASONRY_TYPE";
export const SET_MASONRY_COMPRESSIVE_STRENGTH = "SET_MASONRY_COMPRESSIVE_STRENGTH";
export const SET_MASONRY_IMAGE = "SET_MASONRY_IMAGE";
export const SET_MASONRY_LENGTH = "SET_MASONRY_LENGTH";
export const SET_MASONRY_WIDTH = "SET_MASONRY_WIDTH";
export const SET_MASONRY_HEIGHT = "SET_MASONRY_HEIGHT";

export const SET_MASONRY_JOB_SITE_TEST_DESIGNATION = 'SET_MASONRY_JOB_SITE_TEST_DESIGNATION';
export const SET_MASONRY_JOB_SITE_TEST_NAME = 'SET_MASONRY_JOB_SITE_TEST_NAME';
export const SET_MASONRY_JOB_SITE_TEST_SIZE = 'SET_MASONRY_JOB_SITE_TEST_SIZE';
export const SET_MASONRY_JOB_SITE_TEST_CONSTRUCTION_WORK = 'SET_MASONRY_JOB_SITE_TEST_CONSTRUCTION_WORK';
export const SET_MASONRY_JOB_SITE_TEST_BUILDING_OWNER = 'SET_MASONRY_JOB_SITE_TEST_BUILDING_OWNER';
export const SET_MASONRY_JOB_SITE_TEST_DATE_OF_TESTS = 'SET_MASONRY_JOB_SITE_TEST_DATE_OF_TESTS';
export const SET_MASONRY_JOB_SITE_TEST_PLACE_OF_TESTS = 'SET_MASONRY_JOB_SITE_TEST_PLACE_OF_TESTS';
export const SET_MASONRY_JOB_SITE_TEST_TYPE_OF_STRUCTURE_TO_BE_FIXED = 'SET_MASONRY_JOB_SITE_TEST_TYPE_OF_STRUCTURE_TO_BE_FIXED';

export const SET_MASONRY_JOB_SITE_TEST_TESTS_CARRIED_OUT_BY = 'SET_MASONRY_JOB_SITE_TEST_TESTS_CARRIED_OUT_BY';
export const SET_MASONRY_JOB_SITE_TEST_TESTS_SUPERVISED_BY = 'SET_MASONRY_JOB_SITE_TEST_TESTS_SUPERVISED_BY';
export const SET_MASONRY_JOB_SITE_TEST_DIAMETER_OF_HAMMER_DRILL_BITS = 'SET_MASONRY_JOB_SITE_TEST_DIAMETER_OF_HAMMER_DRILL_BITS';
export const SET_MASONRY_JOB_SITE_TEST_DRILLING_DEPTH = 'SET_MASONRY_JOB_SITE_TEST_DRILLING_DEPTH';
export const SET_MASONRY_JOB_SITE_TEST_EMBEDMENT_DEPTH = 'SET_MASONRY_JOB_SITE_TEST_EMBEDMENT_DEPTH';
export const SET_MASONRY_JOB_SITE_TEST_REF_TEST_RING = 'SET_MASONRY_JOB_SITE_TEST_REF_TEST_RING';
export const SET_MASONRY_JOB_SITE_TEST_INSTALLATION_PROCESS_ACCORDING_TO = 'SET_MASONRY_JOB_SITE_TEST_INSTALLATION_PROCESS_ACCORDING_TO';

export const ADD_MASONRY_RESULT = "ADD_MASONRY_RESULT";
export const UPDATE_MASONRY_RESULT = "UPDATE_MASONRY_RESULT";
export const REMOVE_MASONRY_RESULT = "REMOVE_MASONRY_RESULT";

export const RESET_MATERIAL_STATE = "RESET_MATERIAL_STATE";
export const SET_MATERIAL_STATE = 'SET_MATERIAL_STATE';

export const SET_WOOD_STRENGTH_CLASS = 'SET_WOOD_STRENGTH_CLASS';
export const SET_CUSTOM_WOOD_STRENGTH = 'SET_CUSTOM_WOOD_STRENGTH';

/*
  Action creators
 */
export function setConcreteStrength (value, customValue) {
  return (dispatch, getState) => {
    dispatch({ type: SET_GENERAL_CALC_CONCRETE_STRENGTH, value, customValue, appType: getState().main.appType });
  };
}
export function setConcreteConditions (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_GENERAL_CALC_CONCRETE_CONDITIONS, value, appType: getState().main.appType });
  };
}
export function setBondConditions (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BOND_CONDITIONS, value, appType: getState().main.appType });
  };
}

export function setReinforcementPlate (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_PLATE, value, appType: getState().main.appType });
  };
}
export function setReinforcementEdge (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_EDGE, value, appType: getState().main.appType });
  };
}
export function setReinforcementToLimit (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_TO_LIMIT, value, appType: getState().main.appType });
  };
}
export function setReinforcementLongTemp (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_LONG_TEMPERATURE, value, appType: getState().main.appType });
  };
}
export function setReinforcementShortTemp (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_SHORT_TEMPERATURE, value, appType: getState().main.appType });
  };
}
export function setHoleConditions (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_HOLE_CONDITIONS, value, appType: getState().main.appType });
  };
}

export function setRebarTemperature (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_TEMPERATURE, value, appType: getState().main.appType });
  };
}
export function setRebarLongItem (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_LONG_ITEM, value, appType: getState().main.appType });
  };
}
export function setRebarShortItem (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_SHORT_ITEM, value, appType: getState().main.appType });
  };
}
export function setRebarInstallationConditions (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_INSTALLATION_CONDITIONS, value, appType: getState().main.appType });
  };
}
export function setRebarHoleConditions (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_HOLE_CONDITIONS, value, appType: getState().main.appType });
  };
}
export function setRebarUsingOrillingAid (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_USING_ORILLING_AID, value, appType: getState().main.appType });
  };
}
export function setReinforcementTension (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_TENSION, value, appType: getState().main.appType });
  };
}
export function setReinforcementShear (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_SHEAR, value, appType: getState().main.appType });
  };
}
export function setDrillingConditions (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DRILLING_CONDITIONS, value, appType: getState().main.appType });
  };
}
export function setReinforcementServiceTemp (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REINFORCEMENT_SERVICE_TEMPERATURE, value, appType: getState().main.appType });
  };
}

export function setLightWeightConcrete (active, value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_LIGHT_WEIGHT_CONCRETE, active, value, appType: getState().main.appType });
  };
}

export function setConcreteThickness (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CONCRETE_THICKNESS, value, appType: getState().main.appType });
  };
}

export function setServiceTemperature (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_SERVICE_TEMPERATURE, value, appType: getState().main.appType });
  };
}

export function setMasonryDefinitionType (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_DEFINITION_TYPE, value, appType: getState().main.appType });
  };
}
export function setMasonryType (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_TYPE, value, appType: getState().main.appType });
    materialTabService.getMasonryMaterialInfo(value).then(res => {
      if (!res) return;

      dispatch(setMasonryLength(res.Length));
      dispatch(setMasonryWidth(res.Width));
      dispatch(setMasonryHeight(res.Height));
      dispatch(setCompressiveStrength(res.Strength));
      dispatch(setMasonryImage(res.ImageLink));
      if (res.TextureColor)
        dispatch(setGroundOptions({ masonryTextureColor: res.TextureColor }));
    });
  };
}
export function setCompressiveStrength (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_COMPRESSIVE_STRENGTH, value, appType: getState().main.appType });
  };
}
export function setMasonryImage (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_IMAGE, value, appType: getState().main.appType });
  };
}
export function setMasonryLength (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_LENGTH, value, appType: getState().main.appType });
  };
}
export function setMasonryWidth (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_WIDTH, value, appType: getState().main.appType });
  };
}
export function setMasonryHeight (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_HEIGHT, value, appType: getState().main.appType });
  };
}

export function setMasonryJobSiteTestDesignation (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_DESIGNATION, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestName (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_NAME, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestSize (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_SIZE, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestConstructionWork (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_CONSTRUCTION_WORK, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestBuildingOwner (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_BUILDING_OWNER, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestDateOfTests (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_DATE_OF_TESTS, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestPlaceOfTests (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_PLACE_OF_TESTS, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestTypeOfStructureToBeFixed (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_TYPE_OF_STRUCTURE_TO_BE_FIXED, value, appType: getState().main.appType });
  };
}

export function setMasonryJobSiteTestTestsCarriedOutBy (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_TESTS_CARRIED_OUT_BY, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestTestsSupervisedBy (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_TESTS_SUPERVISED_BY, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestDiameterOfHammerDrillBits (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_DIAMETER_OF_HAMMER_DRILL_BITS, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestDrillingDepth (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_DRILLING_DEPTH, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestEmbedmentDepth (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_EMBEDMENT_DEPTH, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestRefTestRing (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_REF_TEST_RING, value, appType: getState().main.appType });
  };
}
export function setMasonryJobSiteTestInstallationProcessAccordingTo (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MASONRY_JOB_SITE_TEST_INSTALLATION_PROCESS_ACCORDING_TO, value, appType: getState().main.appType });
  };
}

export function addMasonryResult () {
  return (dispatch, getState) => {
    dispatch({ type: ADD_MASONRY_RESULT, appType: getState().main.appType });
  };
}
export function updateMasonryResult (index, value) {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_MASONRY_RESULT, appType: getState().main.appType, index, value });
  };
}
export function removeMasonryResult (toRemove) {
  return (dispatch, getState) => {
    dispatch({ type: REMOVE_MASONRY_RESULT, appType: getState().main.appType, toRemove });
  };
}

export function resetMaterialState (appType){
  return (dispatch, getState) => {
    dispatch({ type: RESET_MATERIAL_STATE, appType: appType || getState().main.appType});
    if (Number(getState().main.localization.designStandard) === standardList['EU'] || 
        Number(getState().main.localization.designStandard) === standardList['AnnexC']) {
      dispatch(setConcreteConditions("1"));
      dispatch(setReinforcementPlate("1"));
      dispatch(setReinforcementEdge("0"));
    } else if (Number(getState().main.localization.designStandard) === standardList['ANZ']){
      dispatch(setConcreteConditions("1")); // VladP: For ANZ we have only uncracked
    } else if (Number(getState().main.localization.designStandard) === standardList['AS5216']){
      dispatch(setReinforcementPlate("1"));
      dispatch(setReinforcementEdge("1"));
    }

    // VladP: Initialize temperatures
    if (getState().main.appType === APP_TYPES.REBAR_REINFORCEMENT) {
      materialTabService.getRangeTemperature().then((temperatures) => {
        if (temperatures && temperatures.length > 0) {
          dispatch(setRebarTemperature(temperatures[0]['InternalName']));
          var temps = temperatures[0]['InternalName'].split(';');
          dispatch(setRebarShortItem(+temps[0]));
          dispatch(setRebarLongItem(+temps[1]));
        }
      });
    } else if (Number(getState().main.localization.designStandard) !== standardList['EU'] && 
              Number(getState().main.localization.designStandard) !== standardList['AnnexC'] &&
              Number(getState().main.localization.designStandard) !== standardList['Masonry']) {
      Promise.all([
        materialTabService.getLongTermTemperature(),
        materialTabService.getShortTermTemperature()
      ])
      .then(([longTermTemps, shortTermTemps]) => {
        if (longTermTemps && longTermTemps.length > 0 && shortTermTemps && shortTermTemps.length > 0) {
          dispatch(setReinforcementLongTemp(longTermTemps[0]['InternalName']));
          dispatch(setReinforcementShortTemp(shortTermTemps[0]['InternalName']));
        }
      }); 
    } else if (Number(getState().main.localization.designStandard) === standardList['Masonry']) {
      materialTabService.getMasonryServiceTemperature().then(res => {
        dispatch(setServiceTemperature(+res["RunName"]));
      });
    }
  };
}

export function setMaterialState(state) {
  return { type: SET_MATERIAL_STATE, state };
}

export function setWoodStrengthClass(value) {
  return (dispatch, getState) => {
    dispatch({ 
      type: SET_WOOD_STRENGTH_CLASS, 
      value,
      appType: getState().main.appType 
    });
  };
}
export function setCustomWoodStrength(value) {
  return (dispatch, getState) => {
    dispatch({ 
      type: SET_CUSTOM_WOOD_STRENGTH, 
      value,
      appType: getState().main.appType 
    });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/selectors/material/actions.js